import { DataBean } from "../DataBean";

export class AttentionOffice extends DataBean {

    public async getAttentionOfficeCatalog(idOffice: number): Promise<any> {
        return this.getCustomService(
            "QuickTurnService", 
            "java.util.List_getAttentionOfficeCatalog_Number", 
            [idOffice]);
    }

    public async getAttentionOfficeCatalogByChannelType(channelType: number): Promise<any> {
        return this.getCustomService(
            "QuickTurnService", 
            "java.util.List_getAttentionOfficeCatalogByChannelType_Number", 
            [channelType]);
    }

}
